module.exports = __webpack_public_path__ + "static/media/48376010_2308761889198989_5440093885936173056_o-thumb.39b34773.jpg";